import React, {Component} from 'react';
import MainLayout from "../../components/layouts/MainLayout";
import {withRouter} from "../../hoc/withRouter";
import withAuth from "../../hoc/withAuth";
import {Button, Card, Col, Form, Input, Modal, Row} from "antd";
import {UpdateDdmsInvoiceStates} from "./types/UpdateDdmsInvoiceTypes";
import CurrencyInput from "react-currency-input-field";
import {taxOtodisService} from "../../services/otodisApi/TaxOtodisService";

export interface UpdateDdmsInvoiceProps {
}

class UpdateDdmsInvoice extends Component<UpdateDdmsInvoiceProps & any, UpdateDdmsInvoiceStates> {
    private readonly initState!: UpdateDdmsInvoiceStates;

    constructor(props: UpdateDdmsInvoiceProps & any | any) {
        super(props);

        this.initState = {
            dealerCode: props.match.params.dealerCode.replace(/-/g, '#'),
            submitting: false,
            orderCode: "",
            ddmsReceiverName: "",
            ddmsIdOrder: "",
            ddmsNoInvoice: "",
            fineInvoice: 0,
        }
        this.state = {...this.initState}
    }

    onDealerChange = async (data: any) => {
        this.setState({
            dealerCode: data.value,
        });
    }

    onFieldChange = <T extends keyof Pick<any, "fineInvoice" | "orderCode" | "ddmsReceiverName" | "ddmsIdOrder" | "ddmsNoInvoice">>(target: T, value: any) => {
        const currentState: any = {...this.state};
        switch (target) {
            case "orderCode":
                currentState.orderCode = value;
                break;
            case "ddmsReceiverName":
                currentState.ddmsReceiverName = value;
                break;
            case "ddmsIdOrder":
                currentState.ddmsIdOrder = value;
                break;
            case "ddmsNoInvoice":
                currentState.ddmsNoInvoice = value;
                break;
            case "fineInvoice":
                currentState.fineInvoice = value;
                break;
        }
        this.setState({
            ...currentState,
        });
    }

    inputVatManual = async () => {
        if (!this.state.orderCode) {
            Modal.error({
                title: 'Proses Gagal',
                content: 'Mohon Lengkapi Data'
            });
            return;
        }
        await this.promisedSetState({
            submitting: true,
        });

        try {
            await taxOtodisService.updateDdmsInvoice({
                dealer_code: this.state.dealerCode,
                order_code: this.state.orderCode,
                ddms_receiver_name: this.state.ddmsReceiverName,
                ddms_id_order: this.state.ddmsIdOrder,
                ddms_no_invoice: this.state.ddmsNoInvoice,
                fine_invoice: this.state.fineInvoice,
            }).then(async successData => {
                Modal.success({
                    title: 'Proses Sukses',
                    content: 'data berhasil di upload '
                });
                await this.promisedSetState({
                    submitting: false,
                    orderCode: "",
                });
            });
        } catch (e) {
            Modal.error({
                title: 'Proses Gagal',
                content: 'Server Menolak Inputan Anda :' + e
            });
            await this.promisedSetState({
                submitting: false,
            });
        }
    }

    async componentDidMount() {

    }

    promisedSetState = (newState: any) => new Promise((resolve: any) => this.setState(newState, resolve));

    render() {
        return (
            <React.Fragment>
                <MainLayout onChangeDealer={this.onDealerChange} breadcrumbPath={`Pajak`} breadcrumbMenu={`Rubah Faktur Ddms`} defaultSelectedKeys={['m-tax-update-ddms-invoice']} defaultOpenKeys={['sm-document']}>

                    <Row>
                        <Col xs={24} xl={8}>
                            <Card title="Rubah Faktur DDMS" style={{margin: 10}}>
                                <Form layout="vertical">
                                    <Form.Item label="Kode Order">
                                        <Input value={this.state.orderCode} placeholder="Kode Order" onChange={event => this.onFieldChange("orderCode", event.target.value)}/>
                                    </Form.Item>
                                    <Form.Item label="Nama Konsumen DDMS">
                                        <Input value={this.state.ddmsReceiverName} placeholder="Nama Konsumen DDMS" onChange={event => this.onFieldChange("ddmsReceiverName", event.target.value)}/>
                                    </Form.Item>
                                    <Form.Item label="ID ORDER DDMS">
                                        <Input value={this.state.ddmsIdOrder} placeholder="ID ORDER DDMS" onChange={event => this.onFieldChange("ddmsIdOrder", event.target.value)}/>
                                    </Form.Item>
                                    <Form.Item label="Nomor Faktur DDMS">
                                        <Input value={this.state.ddmsNoInvoice} placeholder="Nomor Faktur DDMS" onChange={event => this.onFieldChange("ddmsNoInvoice", event.target.value)}/>
                                    </Form.Item>
                                    <Form.Item label="Komponen Denda">
                                        <CurrencyInput className={'ant-input'} value={this.state.fineInvoice} onValueChange={value => this.onFieldChange("fineInvoice", value ? parseFloat(value) : 0)}/>
                                    </Form.Item>

                                    <br/><br/>
                                    <Button type={"primary"} loading={this.state.submitting} onClick={() => this.inputVatManual()}> Rubah Faktur DDMS</Button>
                                </Form>
                            </Card>
                        </Col>
                    </Row>
                </MainLayout>
            </React.Fragment>
        );
    }
}

export default (withAuth(withRouter(UpdateDdmsInvoice), 39));
